<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center" v-if="qaFound==false">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Асуулгад оролцох</h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <input
                        v-model.trim="qaCode"
                        type="text"
                        class="form-control"
                        id="exampleInputEmail"
                        aria-describedby="emailHelp"
                        placeholder="Асуулгын код"
                      >
                    </div>

                    <div class="row">
                      <div class="col form-group">
                        <input
                          v-model.trim="userName"
                          type="text"
                          class="form-control"
                          placeholder="Таны нэр"
                        >
                      </div>
                      <div class="col form-group">
                        <input
                          v-model.trim="userPhone"
                          type="text"
                          class="form-control"
                          placeholder="Таны утасны дугаар"
                        >
                      </div>
                    </div>

                    <hr>
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">Хадгалах</div>
                      </div>
                    </div>
                    <hr>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12" v-if="qaFound==true && qa!=null" >
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
              <div class="row">
                  <div class="col-lg-12">
                    <div class="p-5">
                       <div class="text-center">
                        <h2 class="h2 text-gray-900 mb-4">{{qa.name}}</h2>
                      </div>
                      <p class="text-center">{{qa.description}}</p>
                      <p class="text-center">Нэр:{{userName}}</p>
                      <p class="text-center">Утас:{{userPhone}}</p>
                      <hr/>
                      <h3 class="h4 text-center">Та доорх асуултанд хариулна уу</h3>
                      
                      <div v-if="questions!=null && questions.length>0">
                        <div
                          class="card shadow mb-4"
                          v-for="(question, index) in questions"
                          v-bind:key="question.id"
                        >
                          <div class="card-header py-3">
                            <div class="row justify-content-between">
                              <div class="col col-12">
                                <h3 class="m-0 font-weight-bold text-primary">{{index+1}}. {{question.name}}</h3>
                              </div>
                            </div>

                            <p>{{question.description}}</p>

                            <div class="my-4" v-if="question.answers!=null && question.answers.length>0">
                              <ul class="list-group">
                                <li
                                  v-for="(answer) in question.answers"
                                  v-bind:key="answer.id"
                                  class="list-group-item"
                                  @click="answerQuestion(question, answer)"
                                  v-bind:class="[question.useranswer!=null && question.useranswer.answer!=null && question.useranswer.answer.id==answer.id ? 'answered' : '']"
                                >
                                  <div class="row">
                                    <div class="col col-12">{{answer.name}}</div>
                                    <!-- <div class="col col-2"><span class="badge badge-primary badge-pill">{{answer.votedCount}}</span></div> -->
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div v-else class="alert alert-success">Одоогоор энэ асуултанд хариулт оруулаагүй байна.</div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>

              </div>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
 var colors=['#000000', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'];
export default {
  name: "PublicQA",
  data() {
    return {
      performingRequest: false,
      qaCode: "",
      userName: "",
      userPhone: "",
      qaFound: false,
      qa: null,
      questions: []
    };
  },
  methods: {
    save() {
      this.performingRequest = true;
      if (
        this.qaCode != null &&
        this.qaCode != "" &&
        this.userPhone != null &&
        this.userPhone != ""
      ) {
        fb.db.collection("asuulga").where("postId", "==", this.qaCode).limit(1).get().then(querySnapshot=>{
            querySnapshot.forEach(doc=>{
              if(doc.exists){
                this.qaFound=true;
                let qa=doc.data()
                qa.id=doc.id
                this.qa=qa
                this._getQuestionsFromQA(doc.ref)
              }
            });
        })
        .catch(function(error) {
            console.log("Error getting documents: ", error);
        });

      }
    },
    _getQuestionsFromQA(qaRef){
      qaRef.collection("questions").where("public", "==", true).onSnapshot(querySnapshot=> {
          this.questions=[]
          querySnapshot.forEach(doc=> {
              let object=doc.data()
              object.id = doc.id
              object.answers=[]
              this._getAnswers(object, doc.ref)
              this._getUserAnswer(object, doc.ref)
              this.questions.push(object);
          });
      
      });
    },
     _getUserAnswer(question, ref){
        if(question.useranswer==null || question.useranswer==undefined)
                question.useranswer=null;
            ref.collection("votedusers").doc(this.userPhone).onSnapshot(doc=> {
                question.useranswer=null;
                if (doc.exists) {
                    question.useranswer=doc.data()
                }

            });  
      },
    _getAnswers(question, ref){
      if(question.answers==null || question.answers==undefined)
          question.answers=[];
      ref.collection("answers").onSnapshot(querySnapshot=> {
          question.answers=[];
          let data=[]
          let index=0;
          let answered=false
          querySnapshot.forEach(doc=> {
              let answer=doc.data()
                  answer.id = doc.id
              if(answer.votedCount!=null && answer.votedCount>0)
                answered=true;
                  question.answers.push(answer);
                  index++
          });
          if(answered==true){
     
          }
          else{
            question.datacollection=null
            question.statData=null
          }
      });

  },
  getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
  },
  answerQuestion(question, answer){
      if(question.useranswer==null){
          var questionRef=fb.db.collection("asuulga/"+this.qa.id+"/questions").doc(question.id);
          var ref=questionRef.collection("votedusers").doc(this.userPhone)
          var answerRef=questionRef.collection("answers").doc(answer.id)
          ref.set(
              {
                  userId:this.userPhone,
                  userName:this.userName,
                  guest:true,
                  date:new Date(),
                  isCorrect: answer.correct,
                  answer:answerRef, 
                  answerId: answer.id
              }
          )
          answerRef.update({votedCount:fb.firestore.FieldValue.increment(1)})
          var questionCountRef=fb.db.collection("asuulga/"+this.qa.id+"/votedCount").doc(question.id);
          questionCountRef.update({votedCount:fb.firestore.FieldValue.increment(1), questionId:question.id})
      }
  },


    remove(index, array) {
      if (array != null && array.length > 0) array.splice(index, 1);
    }
  }
};
</script>

